<template>
  <div class="box">
    <!-- 头部 -->
    <div class="wrap">
      <Header :data="data" />
    </div>
    <!-- 重难点 -->
    <div class="wrap">
      <Rub :data="data" />
    </div>
    <!-- 学习目标、目标达成 -->
    <div class="wrap">
      <Target :data="data" />
    </div>
    <!-- 综合表现 -->
    <div class="wrap">
      <Evaluation :data="data" />
    </div>
    <!-- 老师的话 -->
    <div class="wrap teacher-words">
      <teacher-words :data="data" />
    </div>
  </div>
</template>

<script>
import Header from './header'
import Rub from './rub'
import Target from './target'
import Evaluation from './evaluation'
import TeacherWords from './teacherWords'
import { post } from '@/utils/ajax'

export default {
  components: {
    Header,
    Rub,
    Target,
    Evaluation,
    TeacherWords
  },
  data () {
    return {
      data: {}
    }
  },
  methods: {
    async refresh () {
      const res = await post(`/edu/zone/growth/student/profile/${this.$route.query.student_profile_id}/view`)
      this.data = res
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style lang="stylus" scoped>
@import './view.styl';

.el-card {
  border: 0;
  box-shadow: 0 2px 12px 0 rgba($themeColor, 0.1);
}

>>>.el-card__body {
  padding: 20px 15px;
}

.box {
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.slider {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  .el-slider {
    display: contents;

    >>>.el-slider__button {
      border: solid 2px $themeColor;
    }

    >>>.el-slider__bar {
      background: $themeColor;
    }
  }

  .title {
    margin-right: 30px;
    white-space: nowrap;
  }

  >>>.el-tooltip {
    box-shadow: 0px 2px 4px 0px rgba(233, 233, 233, 0.5);
  }
}

.teacher-words {
  margin-bottom: 15px;
}
</style>
